import * as React from 'react';

import { cn } from '@/lib/utils';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  /** When true, paints rose-tinted error rings. */
  error?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(
          'flex h-12 w-full rounded-2xl bg-card/60 px-4 text-[15px] text-foreground placeholder:text-muted-foreground/70',
          'ring-1 ring-foreground/10 backdrop-blur-sm outline-none transition-all',
          'focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:bg-card/80',
          'disabled:cursor-not-allowed disabled:opacity-60',
          error &&
            'ring-rose-500/50 focus-visible:ring-rose-500/70 placeholder:text-rose-300/40',
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
